// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LnLiP","colBig":"styles_colBig__9uxZU","colSmall":"styles_colSmall__3eMFB"};